import React from 'react';

const ModalAjuda = ({
  aberto,
  setAberto,
  titulo,
  children,
  opcaoFechar = true,
}) => {
  React.useEffect(() => {
    const modal = document.getElementById('modal-ajuda');

    if (aberto) {
      modal.close();
      modal.addEventListener('click', cliqueForaListener);
      document.body.removeEventListener('keydown', listener);
      modal.showModal();
    } else {
      modal.addEventListener('click', cliqueForaListener);
      document.body.addEventListener('keydown', listener);
      modal.close();
    }
  }, [aberto]);

  var listener = function (event) {
    if (event.key === 'Escape') {
      setAberto(false);
    }
  };

  var cliqueForaListener = function (event) {
    if (!event.target.closest('dialog > div')) {
      setAberto(false);
    }
  };

  return (
      <dialog
        className={'bg-superficie elev5 aberto'}
        id='modal-ajuda'
        data-esc=''>
        {children}
      </dialog>
  );
};
export default ModalAjuda;
